import React from 'react';

type ProteinApiDataProps = {
  label: string;
  value?: string;
};

const ProteinApiData = ({ label, value }: ProteinApiDataProps) => {
  return (
    <div id="addprotein-apidata-row" className="w-[100%] h-[5.48%] flex flex-row">
      <div id="addprotein-apidata-infoleft" className="w-[53.08%] h-[100%]">
        <div id="addprotein-apidata-field" className="w-[48.51%] h-[100%] flex flex-row">
          <div
            id="addprotein-apidata-label"
            className="w-[33.2%] h-[100%] min-w-0 text-[0.923rem] text-[#1B1B1B] flex items-center"
            title={label}
          >
            <span className="truncate">{label}</span>
          </div>
          <div
            id="addprotein-apidata-inputcontainer"
            className="w-[66.8%] h-[100%] place-content-center"
          >
            <input
              id="addprotein-apidata-input"
              className="w-[100%] h-[92.4%] text-[1.077rem] text-[#707070]"
              type="text"
              value={value ?? ''}
              readOnly
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProteinApiData;
